import { useTranslation } from 'react-i18next'

import { Div, Text } from 'ui'
import useResponsive from 'utils/hooks/useResponsive'
import CircleColor from '../CircleColor/index'

import Image from './Image'


export const Hero = () => {

  const { isTab, isTabLand, isBigDesktop } = useResponsive()
  const { t } = useTranslation()

  return (
    <Div
      display='flex'
      flexDirection='column'
      placeItems='center'
      justifyContent='space-between'
      height={isTabLand || isBigDesktop ? '100%' : 'calc(100vh - 70px)'}
      position='relative'
      maxWidth={2040}
      width='100%'
    >
   
      <Div
        width='95%'
        maxWidth={750}
        margin='100px auto 0'
        display='flex'
        flexDirection='column'
        gap={16}
      >
        <Text size={isTab ? '2xl' : '5xl'} color='headline' align='center'>
          {t('flixx_hero_whatIsFlixx')}
        </Text>
        <Text align='center'>
          {t('flixx_hero_description')}
        </Text>
      </Div>


      <Div
        flexGrow={1}
        display='flex'
        justifyContent='center'
        width='100%'
        maxWidth={1000}
        minHeight={0}
      >
        <Div
          display='flex'
          width='100%'
          minWidth={600}
          transform={isTabLand  ? 'translateY(0)' : 'translateY(-15%)'}
          marginTop={isTabLand  ? 40 : 0}
        >
          <Image
            height='100%'
            width='100%'
            text={t('flixx_hero_imFlixx')}
          />
        </Div>
      </Div>

      <CircleColor opacity={.32} left={0} />
      <CircleColor opacity={.32} right={0} />
      <CircleColor opacity={.32} bottom={0} left='50%'  transform='translateX(-50%)' />

    </Div>
  )
}
